import { JsonTypeDeriver } from '../type-utils';

export interface Pageable {
  meta: {
    item_count?: number;
  };
  links: {
    first?: string;
    last?: string;
    self?: string;
    prev?: string;
    next?: string;
  };

  /**
   * Does the pageable have more pages available?
   *
   * @returns {boolean} - true if there are more pages; false otherwise
   **/
  hasMorePages?: () => boolean;
}

export class PageableUtilsClass implements JsonTypeDeriver<Pageable> {
  /**
   * Does the pageable have more pages available?
   *
   * @returns {boolean} - true if there are more pages; false otherwise
   **/
  hasMorePages(pageable: Pageable): boolean {
    return pageable.links && pageable.links.next ? true : false;
  }

  /**
   * Adds derived properties to a pageable instance.
   *
   * @param {Pageable} item - The pageable to extend.
   * @returns {Pageable} - The pageable, with derived properties added
   **/
  addDerivedProperties(pageable: Pageable): Pageable {
    const hasMorePages = (): boolean => this.hasMorePages(pageable);
    return Object.assign({}, pageable, { hasMorePages });
  }
}

export const PageableUtils = new PageableUtilsClass();
